import axios from "axios"

const baseURL = process.env.REACT_APP_API_URL

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("auth_token")
        if (token) {
            config.headers['x-access-token'] = token
            config.headers['Cache-Control'] = 'no-cache' 
        }

        return config

    },
    (error) => {
        Promise.reject(error)
    }
)

axios.interceptors.response.use(
    (res) => {
        if (res.status === 200) {
            return res
        }
        return res
    },
    (err) => {
        return Promise.reject(err)
    }
)

export { axios, baseURL }